import { useEffect } from 'react'
import useServiceData from './useServiceData'
import { useModal } from './useModal'
import { image } from '../utils/data/baseUrl'
import { useTranslation } from '../translations'
import { isAlfaGameActive } from '../utils/game/isAlfaGameActive'
import { isJumperForMeAssets } from '../utils/game/isJumperForMeAssets'
import { isJumperAdidasAssets } from '../utils/game/isJumperAdidasAssets'
import { isPlatformBourjoisAssets } from '../utils/game/isPlatformBourjoisAssets'
import { isJumperRimmelAssets } from '../utils/game/isJumperRimmelAssets'

const boostersTutorialCopyright = {
  magnet: {
    title: 'boostersTutorial.magnet.title',
    text: 'boostersTutorial.magnet.text',
  },
  big_basket: {
    title: 'boostersTutorial.big_basket.title',
    text: 'boostersTutorial.big_basket.text',
  },
  infection: {
    title: 'boostersTutorial.infection.title',
    text: 'boostersTutorial.infection.text',
  },
  reverse: {
    title: 'boostersTutorial.reverse.title',
    text: 'boostersTutorial.reverse.text',
  },
  jetpack: {
    title: 'boostersTutorial.jetpack.title',
    text: 'boostersTutorial.jetpack.text',
  },
  spring: {
    title: 'boostersTutorial.spring.title',
    text: 'boostersTutorial.spring.text',
  },
}

const jumperOldBoosterImages = ['jetpack', 'spring']

const getBoosterTutorialImage = ({ boosterName, type }) => {
  if (type === 'jumper' && isJumperAdidasAssets() && jumperOldBoosterImages.includes(boosterName)) {
    return image(`games/boostersTutorialAdidas/boosterTutorial-${boosterName}.png`)
  }

  if (type === 'jumper' && isJumperRimmelAssets() && jumperOldBoosterImages.includes(boosterName)) {
    return image(`games/boostersTutorialRimmel/boosterTutorial-${boosterName}.png`)
  }

  if (type === 'platform' && isPlatformBourjoisAssets()) {
    return image(`games/boostersTutorialBourjois/boosterTutorial-${boosterName}.png`)
  }

  if (type === 'platform' && isAlfaGameActive()) {
    return image(`games/boostersTutorialAlfa/boosterTutorial-${boosterName}.png`)
  }

  if (type === 'jumper' && !isJumperForMeAssets() && jumperOldBoosterImages.includes(boosterName)) {
    return image(`games/boostersTutorial/old/boosterTutorial-${boosterName}.png`)
  }

  return image(`games/boostersTutorial/boosterTutorial-${boosterName}.png`)
}

export const useBoostersTutorial = ({ wrapper, toTutorial, toPlaying, type }) => {
  const { get, save } = useServiceData()
  const { addModal } = useModal()
  const { t } = useTranslation()

  useEffect(() => {
    if (!wrapper) return

    const getBooster = ({ name, boosterType }) => {
      const boosterName = name ?? boosterType
      const modalsData = get('modalsData') ?? {}
      const tutorialArray = modalsData.boosterTutorials ?? []

      if (!tutorialArray.includes(boosterName)) {
        save('modalsData', { ...modalsData, boosterTutorials: [...tutorialArray, boosterName] })

        toTutorial()

        addModal({
          type: 'startGameModal',
          props: {
            isBoosterTutorial: true,
            onClose: toPlaying,
            buttonText: t('other.understand'),
            image: getBoosterTutorialImage({ boosterName, type }),
            ...boostersTutorialCopyright[boosterName],
          },
        })
      }
    }

    wrapper.eventBus.addEventListener('booster:enabled', getBooster)
    return () => wrapper.eventBus.removeEventListener('booster:enabled', getBooster)
  }, [wrapper])
}
